export const platforms = {
  windows: 'windows',
  macintosh: 'macintosh',
  linux: 'linux',
  android: 'android'
}
